"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LeitungslaengeUeberstandLock = exports.LeitungBeschriftung = void 0;
var LeitungBeschriftung;
(function (LeitungBeschriftung) {
    LeitungBeschriftung["keine"] = "Keine";
    LeitungBeschriftung["folienlabel"] = "Folienlabel";
})(LeitungBeschriftung = exports.LeitungBeschriftung || (exports.LeitungBeschriftung = {}));
var LeitungslaengeUeberstandLock;
(function (LeitungslaengeUeberstandLock) {
    LeitungslaengeUeberstandLock["none"] = "none";
    LeitungslaengeUeberstandLock["laengeOnly"] = "laengeOnly";
    LeitungslaengeUeberstandLock["festpunktOnly"] = "festpunktOnly";
    LeitungslaengeUeberstandLock["mitnehmerOnly"] = "mitnehmerOnly";
    LeitungslaengeUeberstandLock["laengeAndFestpunkt"] = "laengeAndFestpunkt";
    LeitungslaengeUeberstandLock["laengeAndMitnehmer"] = "laengeAndMitnehmer";
    LeitungslaengeUeberstandLock["festpunktAndMitnehmer"] = "festpunktAndMitnehmer";
})(LeitungslaengeUeberstandLock = exports.LeitungslaengeUeberstandLock || (exports.LeitungslaengeUeberstandLock = {}));
//# sourceMappingURL=LeitungModel.js.map